var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.031,
    height: 10.999,
    viewBox: "0 0 11.031 10.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "missed.svg",
    d: "M90.535,326.5a.553.553,0,0,0-.783,0l-8.632,8.638v-4.748a.569.569,0,0,0-.472-.567.556.556,0,0,0-.638.55v6.109a.557.557,0,0,0,.555.555H86.1a.568.568,0,0,0,.566-.472.556.556,0,0,0-.55-.639H81.9l8.632-8.638A.56.56,0,0,0,90.535,326.5Z",
    transform: "translate(-79.86 -326.184)",
    fill: "#ef0f0f",
    stroke: "#ef0f19",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/missed.511f8af0.svg";
export { ForwardRef as ReactComponent };